<form [formGroup]="form">
	<h1 mat-dialog-title>Add a new customer</h1>
	<div mat-dialog-content>
		<div class="pt-2" fxLayoutGap="20px" fxLayout="row">
			<mat-form-field>
				<input
					matInput
					formControlName="companyName"
					placeholder="Company Name"
					required
					maxlength="50"
				/>
				<mat-error>Required</mat-error>
			</mat-form-field>
		</div>
		<div class="pt-2" fxLayoutGap="20px" fxLayout="row">
			<mat-form-field>
				<input
					matInput
					formControlName="billingEmail"
					placeholder="Billing Email"
					required
					maxlength="50"
				/>
				<mat-error
					*ngIf="this.form.get('billingEmail').hasError('required')"
					>Required</mat-error
				>
				<mat-error
					*ngIf="this.form.get('billingEmail').hasError('email')"
					>Must be valid email address</mat-error
				>
			</mat-form-field>
		</div>
		<rpshared-address formControlName="address"></rpshared-address>
	</div>
	<div mat-dialog-actions fxLayoutAlign="end">
		<button mat-button type="button" color="primary" mat-dialog-close>
			Cancel
		</button>
		<button
			mat-button
			color="primary"
			(click)="addCustomer()"
			[disabled]="!form.valid"
		>
			Add
		</button>
	</div>
</form>
